import { MultiValuedList } from '../../MultiValuedList'
import { TextMultiValuedListItem } from '../../TextMultiValuedList'
import { BuildingMultiValuedListMoreItem } from '../BuildingMultiValuedListMoreItem'

import { filterByChildren } from './BuildingMultiValuedList.utils'

function BuildingMultiValuedList({
  Item = TextMultiValuedListItem,
  MoreItem = BuildingMultiValuedListMoreItem,
  filter = filterByChildren,
  ...restProps
}) {
  return (
    <MultiValuedList
      {...restProps}
      Item={Item}
      MoreItem={MoreItem}
      filter={filter}
    />
  )
}

export default BuildingMultiValuedList
